<template>
    <div class="home">
        <section class="outter">
            <img src="../../assets/images/home/kv_bg.png"
                 class="d-none d-sm-block banner-bg" />
            <img src="../../assets/images/home/kv_m.jpg"
                 class="d-sm-none banner-bg" />
            <div class="banner-text">
                <div class="text-area">
                    <div class="slogan">
                        <span class="text-sm">幫你買對</span>
                        <span class="text-md">找出你的</span><br/>
                        <span class="text-lg">最佳保障方案</span>
                    </div>
                    <!-- for PC 按鈕:找專人服務 -->
                    <div class="d-none d-sm-block">
                        <button class="btn btnStyle rounded-pill btnStyle-secondary"
                                @click.prevent="goReserve()"
                                :data-ga-element="
                                        `${logBlockName}找專人服務`
                                    ">
                            找專人服務
                        </button>
                    </div>
                </div>
            </div>

            <img src="../../assets/images/home/kv_team.png"
                 width="100%"
                 class="img-team d-none d-sm-block"
                 alt="富邦保險全台第一" />
            <img src="../../assets/images/home/kv_geometry.png"
                 alt="富邦保險全台第一"
                 class="img-symbol d-none d-sm-block">
            <!-- for手機 按鈕:找專人服務 -->
            <div class="d-flex justify-content-around d-sm-none mb-btn">
                <button class="btn btnStyle rounded-pill  btnStyle-secondary"
                        @click.prevent="goReserve()"
                        :data-ga-element="
                                        `${logBlockName}找專人服務`
                                    ">
                    找專人服務
                </button>
            </div>
        </section>
        <section class="w-100 content">
            <img src="../../assets/images/home/leftdescorate.svg"
                 alt="背景圖1"
                 class="bg-pattern1 d-none d-sm-block" />
            <img src="../../assets/images/home/rightcircledescorate.svg"
                 alt="背景圖2"
                 class="bg-pattern2 d-none d-sm-block" />
            <img src="../../assets/images/home/rightdescorate.svg"
                 alt="背景圖3"
                 class="bg-pattern3 d-none d-sm-block" />
            <img src="../../assets/images/home/yellowCircle.svg"
                 alt="背景圖4"
                 class="bg-pattern4 d-none d-sm-block" />
            <p class="title mx-3">名列Brand Finance 全球百大保險品牌，
                <span class="text-nowrap">全台第一</span>
            </p>
            <p class="subtitle mt-3 mb-4 mx-3">國內擁有約530多個業務據點，
                <span class="text-nowrap">服務888萬張保單。</span>
            </p>
            <div class="text-center mb-sm-4 mb-4 mx-3">
                <button class="btn btnStyle rounded-pill btnStyle-secondary btn-freecontact"
                        @click.prevent="goReserve()"
                        :data-ga-element="`${logBlockName}免費諮詢`">
                    免費諮詢
                </button>
            </div>
            <div class="d-flex justify-content-center py-2 mx-3">
                <iframe id="ytplayer"
                        class="yt-main"
                        :style="{'height': `${ytHeight}px`}"
                        type="text/html"
                        src="https://www.youtube.com/embed/ml8AjAhYVdk"
                        frameborder="0"
                        allowfullscreen
                        :data-ga-element="`${logBlockName}影片_形象影片`" />
            </div>
            <article class="text-center text pt-4 pb-3">
                <p class="mb-3">我們都怕……遇到不適合的業務員、
                    <span class="text-nowrap">買到不需要的保單</span><br/> 在這裡, 你的擔心不再是擔心</p>
                <p class="mb-0 mb-md-2">
                    我們精選各領域的業務菁英<br/> 專業、懂你、沒有任何人情壓力
                    <br/> 只需考慮你最真切的需要
                </p>
            </article>

        </section>
        <section class="media-slider d-none d-md-block">
            <Carousel/>
        </section>
        <section class="media-slider mb-4 d-block d-md-none">
            <Swiper/>
        </section>
        <Bottom />
        <Notification />
    </div>
</template>
<script>
import Bottom from './Bottom.vue';
import Carousel from './Carousel.vue';
import Swiper from './Swiper.vue';
import { uuid } from 'uuidv4';
import { request } from '@/service';
import Notification from '@/components/Notification.vue';

export default {
    name: 'Home',
    components: {
        Bottom,
        Carousel,
        Swiper,
        Notification
    },
    data() {
        return {
            logBlockName: '新保險網站_',
            ytHeight: 305,
            bodyWidth: 0,
        };
    },
    mounted() {
        this.$store.dispatch('setMenuActive', '');
        window.addEventListener('resize', this.resizeHandler);
        this.resizeHandler();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    methods: {
        resizeHandler() {
            this.bodyWidth = document.body.offsetWidth >= 768;
            const windowWidth = document.body.offsetWidth;
            this.ytHeight = windowWidth > 540 ? 305 : windowWidth * 0.565;
        },
        goReserve() {
            const data = {
                caseId: uuid(),
                srcId: 'FBAG',
                productId: 'NCP',
            };
            request({
                method: 'POST',
                api: '/reserve/api/authenticate',
                data: data
            }).then((res) => {
                this.$cookies.set('token', res.data.jwt);
                const protocol = window.location.origin;
                window.location = `${protocol}${process.env.VUE_APP_HOST}/reserve`;
            }).catch(() => {
                this.$notify({
                    group: 'alert',
                    title: '系統發生錯誤',
                    type: 'error',
                });
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.outter {
    overflow: hidden;
    position: relative;
    width: 100%;

    .banner-bg {
        width: 120%;
        margin-left: -10%;
        @include media-breakpoint-up(sm) {
            width: 160%;
            margin-left: -30%;
        }
        @include media-breakpoint-up(md) {
            width: 136%;
            margin-left: -18%;
        }

        @include media-breakpoint-up(xl) {
            width: 130%;
            margin-left: -15%;
        }
    }
    .img-team {
        position: absolute;
        top: 18.5%;
        left: 47.6%;
        width: 33.2%;
        @include media-breakpoint-up(sm) {
            top: 18.25%;
            left: 46.6%;
            width: 44.52%;
        }
        @include media-breakpoint-up(md) {
            top: 18.75%;
            left: 47.25%;
            width: 37.42%;
        }
        @include media-breakpoint-up(xl) {
            top: 18.75%;
            left: 47.5%;
            width: 35.85%;
        }
    }
    .img-symbol {
        position: absolute;
        top: 12%;
        left: 42%;
        width: 43.2%;
        @include media-breakpoint-up(sm) {
            top: 12%;
            left: 37%;
            width: 61.2%;
        }
        @include media-breakpoint-up(md) {
            top: 12%;
            left: 39%;
            width: 53.2%;
        }
        @include media-breakpoint-up(xl) {
            top: 12%;
            left: 39.4%;
            width: 49.75%;
        }
    }
}
.banner-text {
    width: 100%;
    z-index: 1;
    position: absolute;
    top: 14%;
    @include media-breakpoint-up(sm) {
        width: 56%;
        top: 10%;
    }
    @include media-breakpoint-up(md) {
        top: 14%;
    }
    @include media-breakpoint-up(lg) {
        top: 14%;
    }
    @include media-breakpoint-up(xl) {
        top: 14%;
    }
    .text-area {
        max-width: 1100px;
        margin: 0 auto;
        // width: 76vw;
        width: fit-content;
        // width: 240px;
        @include media-breakpoint-up(sm) {
            width: 250px;
        }
        @include media-breakpoint-up(md) {
            width: 290px;
        }
        @include media-breakpoint-up(lg) {
            width: 345px;
        }
        @include media-breakpoint-up(xl) {
            width: 380px;
        }
    }

    .slogan {
        margin-top: -1.1rem;
        font-weight: bold;
        color: #ffa031;
        line-height: 1.125;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            width: 9.1vw;
            //   width: 2.25rem;
            border-top: 1px solid #666;
            top: -5px;
            left: -3%;
        }
        &::after {
            content: '';
            position: absolute;
            //   width: 2.25rem;
            border-top: 1px solid #666;
            width: 9.1vw;
            right: -2%;
            bottom: -3%;
        }
        @include media-breakpoint-up(sm) {
            margin-top: 0;
            margin-bottom: 10%;
            &::before {
                width: 4rem;
                top: -4px;
                left: -5px;
            }
            &::after {
                width: 5.25rem;
                bottom: -4px;
                right: 9px;
            }
        }
        @include media-breakpoint-up(md) {
            margin-top: -0.75rem;
            margin-bottom: 7%;
            &::before {
                top: 5px;
            }
            &::after {
                width: 6.25rem;
            }
        }
        @include media-breakpoint-up(lg) {
            margin-top: -0.9rem;
            margin-bottom: 9%;
            &::before {
                width: 4.85rem;
                top: 9px;
            }
            &::after {
                width: 7.5rem;
                bottom: -5px;
            }
        }
        @include media-breakpoint-up(xl) {
            margin-top: -0.9rem;
            margin-bottom: 12%;
            &::before {
                width: 5.5rem;
                top: 15px;
            }
            &::after {
                width: 8rem;
                bottom: -6px;
                right: 9px;
            }
        }
        .text-sm {
            font-weight: normal;
            //   font-size: 27px;
            font-size: 6.5vw;
            color: #333;
            margin-right: 1rem;
            line-height: 1.25;
            &::before {
                content: '';
                width: 1.5vw;
                height: 1.5vw;
                border: 1px solid #666;
                position: absolute;
                left: 14%;
                top: -12%;
            }
            @include media-breakpoint-up(sm) {
                margin-right: 0.75rem;
                font-size: 27px;
                &::before {
                    width: 6px;
                    height: 6px;
                    left: 4rem;
                    top: -8px;
                }
            }
            @include media-breakpoint-up(md) {
                margin-right: 0.75rem;
                font-size: 27px;
                &::before {
                    width: 0.5rem;
                    height: 0.5rem;
                    left: 4.2rem;
                    top: 0;
                }
            }
            @include media-breakpoint-up(lg) {
                margin-right: 0.85rem;
                font-size: 31px;
                &::before {
                    left: 5rem;
                    top: 7px;
                }
            }
            @include media-breakpoint-up(xl) {
                margin-right: 1rem;
                font-size: 33px;
                &::before {
                    left: 5.5rem;
                    top: 9px;
                }
            }
        }
        .text-md {
            font-weight: normal;
            //   font-size: 27px;
            font-size: 6.5vw;
            color: #333;
            line-height: 1.25;
            @include media-breakpoint-up(sm) {
                font-size: 27px;
            }
            @include media-breakpoint-up(md) {
                font-size: 37px;
            }
            @include media-breakpoint-up(lg) {
                font-size: 46px;
            }
            @include media-breakpoint-up(xl) {
                font-size: 52px;
            }
        }
        .text-lg {
            font-weight: bold;
            font-size: 9.5vw;
            //   font-size: 39px;
            color: #ffa031;
            line-height: 1.125;
            position: relative;

            &::after {
                content: '';
                width: 1.5vw;
                height: 1.5vw;
                right: -6%;
                bottom: -1%;
                position: absolute;
                border: 1px solid #666;
            }
            @include media-breakpoint-up(sm) {
                font-size: 39px;
                &::after {
                    width: 6px;
                    height: 6px;
                    right: -13px;
                    bottom: 6px;
                }
            }
            @include media-breakpoint-up(md) {
                font-size: 45px;
                &::after {
                    width: 0.5rem;
                    height: 0.5rem;
                    right: -13px;
                    bottom: 6px;
                }
            }
            @include media-breakpoint-up(lg) {
                font-size: 54px;
            }
            @include media-breakpoint-up(xl) {
                font-size: 60px;
            }
        }
    }
}
.mb-btn {
    margin-top: -4rem;
    margin-bottom: 2rem;
}
.btnStyle {
    color: #fff;
    background-color: #0089d1;
    border-color: #0089d1;
    border: 0;
    font-size: 1.125rem;
    font-weight: bold;
    padding: 0.75rem 8.5% 0.69rem 8.5%;
    @include media-breakpoint-up(sm) {
        padding: 0.5rem 1.5rem 0.5rem 1.5rem;
        font-size: 0.875rem;
    }
    @include media-breakpoint-up(md) {
        padding: 0.6rem 1.6rem 0.5rem 1.6rem;
        font-size: 1rem;
    }
    @include media-breakpoint-up(lg) {
        padding: 0.75rem 2.1875rem 0.69rem 2.1875rem;
        font-size: 1.125rem;
    }
    &:hover {
        color: #fff;
    }
}
.btnStyle-primary {
    background-image: linear-gradient(270deg, #faac6a, #f8943e);
}
.btnStyle-secondary {
    background-image: linear-gradient(270deg, #01b6d2, #0089d1);
}
.content {
    overflow: hidden;
    margin-top: 0;
    position: relative;
    @include media-breakpoint-up(sm) {
        margin-top: -6%;
    }
    .bg-pattern1 {
        position: absolute;
        z-index: -1;
        top: 5%;
        left: -15%;
        width: 27%;
        max-width: 386px;
    }
    .bg-pattern2 {
        position: absolute;
        z-index: -1;
        right: 16%;
        top: 12%;
        width: 11.5%;
        max-width: 160px;
    }
    .bg-pattern3 {
        position: absolute;
        z-index: -1;
        right: -15.75%;
        bottom: 0;
        width: 26.75%;
        max-width: 386px;
    }
    .bg-pattern4 {
        position: absolute;
        top: 63%;
        left: 19.5%;
        max-width: 66px;
        z-index: -1;
        width: 5%;
    }
    .btn-freecontact {
        width: 100%;
        font-size: 1.125rem;
        padding-top: 10px;
        padding-bottom: 8px;
        @include media-breakpoint-up(sm) {
            width: auto;
            padding-right: 2.45rem;
            padding-left: 2.45rem;
        }
    }
    .title {
        line-height: 1.25;
        text-align: center;
        font-weight: bold;
        color: #333;
        font-size: 22px;
        @include media-breakpoint-up(sm) {
            font-size: 26px;
        }
        @include media-breakpoint-up(md) {
            font-size: 30px;
        }
    }
    .subtitle {
        line-height: 1.25;
        text-align: center;
        color: #666;
        font-size: 1rem;
        @include media-breakpoint-up(md) {
            font-size: 18px;
        }
    }
    .yt-main {
        max-width: 100%;
        width: 540px;
        height: 305px;
    }
    .text {
        color: #666;
        line-height: 1.25;
        font-size: 1rem;
        @include media-breakpoint-up(md) {
            line-height: 1.5;
            font-size: 1.125rem;
        }
    }
}
.media-slider {
    width: 100%;
    padding: 0 15px;
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
}
</style>
